import PropTypes from "prop-types";
import { Input, InputNumber } from "top-component-library";
import { FormRow } from "../styles";

const OrderRateLimitSubtotalStep = ({ min, max, messageIfViolated, onChangeMin, onChangeMax, onChangeMessage }) => (
  <div>
    <FormRow>
      <label htmlFor="minimum-order-subtotal">Subtotal Minimum ($)</label>
      <InputNumber id="minimum-order-subtotal" value={min ?? undefined} onChange={onChangeMin} />
    </FormRow>
    <FormRow>
      <label htmlFor="maximum-order-subtotal">Subtotal Maximum ($)</label>
      <InputNumber id="maximum-order-subtotal" value={max ?? undefined} onChange={onChangeMax} />
    </FormRow>
    <h4>Error Message:</h4>
    <FormRow>
      <label htmlFor="message-if-violated-subtotal">Message shown to patrons when their order is blocked</label>
      <Input
        id="message-if-violated-subtotal"
        maxLength={250}
        value={messageIfViolated}
        onChange={(event) => onChangeMessage(event.target.value)}
      />
    </FormRow>
  </div>
);

OrderRateLimitSubtotalStep.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  messageIfViolated: PropTypes.string.isRequired,
  onChangeMin: PropTypes.func.isRequired,
  onChangeMax: PropTypes.func.isRequired,
  onChangeMessage: PropTypes.func.isRequired,
};

OrderRateLimitSubtotalStep.defaultProps = {
  min: null,
  max: null,
};

export default OrderRateLimitSubtotalStep;
